import { useI18N } from "@sundae/react-hooks";
import { Button } from "@sundae/ui-toolkit";
import type { IButtonProps } from "@sundae/ui-toolkit/dist/types/components/atoms/Button/Button";
import { FC } from "react";

import { testIds } from "../../constants/testIds.constants";
import { Actions, useAppContext } from "../../stores";

const ConnectWalletButton: FC<IButtonProps> = ({ size = "sm", ...props }) => {
  const { dispatch } = useAppContext();
  const { t } = useI18N("wallet");

  return (
    <Button
      {...props}
      data-testid={testIds.walletButton.connectWalletButton}
      variant="colored"
      onClick={() => Actions.setConnectWalletOpen(true, dispatch)}
      size={size}
    >
      {t("button.connect")}
    </Button>
  );
};

export default ConnectWalletButton;
